<template>
	<div
		class="side-menu-header-container"
		:class="{ 'ls-publishing': embedded }"
	>
		<div class="side-menu-header">
			<div
				class="side-menu-header-user pointer"
				@click="showMultiOrg && $emit('toggle')"
				@keyup.enter="showMultiOrg && $emit('toggle')"
				role="button"
			>
				<ArrowIcon
					class="org-menu-arrow"
					:direction="open ? 'down' : 'right'"
					v-if="showMultiOrg"
				/>
				<ProfilePic :user="org" size="40px" />
				<div class="side-menu-header-user-info">
					<div class="org-name">
						{{ org.name }}
					</div>
					<div class="side-menu-header-user-name">
						<div class="is-online" v-if="isOnline" />
						<UserName :user="user" id="fullUserName" />
					</div>
				</div>
			</div>

			<span
				class="settings-wheel pointer"
				:title="$t('common_settingsapp')"
				ondragstart="return false;"
				:draggable="false"
				@click="onClickSettings"
				@keydown.enter.prevent="onClickSettings"
				role="button"
			>
				<GearIcon
					type="regular"
					class="gear main-settings"
					:aria-label="$t('common_settingsapp')"
					@keyup.enter="onClickSettings"
				/>
			</span>
		</div>
		<AccountPicker :open="open" allowSignin hideCurrent />
	</div>
</template>

<script>
import store, { getUser } from '@/store'
import { ArrowIcon, GearIcon } from '@/icons'
import { ProfilePic, UserName } from '@/components/common'
import AccountPicker from './AccountPicker'

export default {
	name: 'SidebarHeader',
	props: ['open'],
	components: {
		ArrowIcon,
		GearIcon,
		ProfilePic,
		AccountPicker,
		UserName,
	},

	data() {
		return {
			user: store.auth.user,
			org: {},
		}
	},

	emits: ['toggle', 'settings'],

	methods: {
		onClickSettings() {
			this.$emit('settings')
		},
	},

	computed: {
		embedded() {
			return store.config.embedded
		},
		isOnline() {
			return store.userIsActive
		},
		showMultiOrg() {
			return !store.config.integration_name
		},
	},

	created() {
		this.org = store.auth.user.organizations[0]

		this.$onEventBus({
			'user-update': () => {
				this.user = getUser(store.auth.user.id)
			},
			OrgUpdated: () => {
				this.user = store.auth.user
				this.org = store.auth.user.organizations[0]
			},
		})
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

$border: var(--neutral-40040);
$online-size: 6px;

.side-menu-header-container {
	border-bottom: 1px solid $border;
	padding-bottom: 1px;
}
.side-menu-header {
	z-index: 1;
	height: 59px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px 0 8px;
	// background-color: #f0f2f3;
	.side-menu-header-user {
		display: flex;
		align-items: center;
		.side-menu-header-user-info {
			max-width: 168px;
			margin-left: 8px;
			.org-name {
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			.side-menu-header-user-name {
				display: flex;
				align-items: center;
				font-size: 12px;
				font-family: Avenir-Book;
				.is-online {
					flex-shrink: 0;
					width: $online-size;
					height: $online-size;
					border-radius: $online-size;
					overflow: hidden;
					margin-right: 4px;
					background: var(--teal-300);
				}
				#fullUserName {
					flex-grow: 1;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
		}
	}
	.settings-wheel {
		height: 20px;
	}
	:deep(.online-indicator) {
		border-color: #f0f2f3 !important;
	}
	.org-menu-arrow {
		margin-right: 8px;
	}
	.gear {
		font-size: 20px;
		color: var(--neutral-400);
	}
	:deep(.user-display-name) {
		display: block;
	}
}
</style>
